(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collector-coming-soon"] && !Shopify.designMode) return;
  try {
    
function initialiseCollectorGalleries(){document.querySelectorAll('[data-collector-launch]').forEach(section=>{if(section.dataset.galleryBound)return;section.dataset.galleryBound='true';const image=section.querySelector('.lc-hero');const caption=section.querySelector('[data-gallery-caption]');const buttons=section.querySelectorAll('[data-image]');buttons.forEach(button=>button.addEventListener('click',()=>{image.removeAttribute('srcset');image.removeAttribute('sizes');image.src=button.dataset.image;image.alt=button.dataset.alt;caption.textContent=button.dataset.caption;buttons.forEach(other=>other.setAttribute('aria-pressed',String(other===button)));}));});}initialiseCollectorGalleries();document.addEventListener('shopify:section:load',initialiseCollectorGalleries);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
